import React, { Component } from 'react';
import Icon from '../Icon';
import { Popover, Badge, Avatar } from 'antd';
import { Link } from 'dva/router';
import cx from 'classnames';
import './style/index.less';
import SearchBox from './SearchBox';
import $$ from 'cmn-utils';
import {framework_tool } from '../../../tool';
let {ossFileUtils} = framework_tool

/**
 * 其本本局头部区域
 */
class NavBarBase extends Component {
  state = {
    openSearchBox: false
  };

  user = storage.getStorage('user') ? storage.getStorage('user') : { nickName: '游客' };

  static defaultProps = {
    fixed: true,
    theme: '' //'bg-dark',
  };

  componentDidMount() {
  }

  toggleFullScreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }

  onCloseSearchBox = () => {
    this.setState({
      openSearchBox: false
    });
  };

  onOpenSearchBox = () => {
    this.setState({
      openSearchBox: true
    });
  };


  render() {
    const { openSearchBox } = this.state;
    const {
      fixed,
      theme,
      onCollapseLeftSide,
      collapsed,
      onExpandTopBar,
      toggleSidebarHeader,
      isMobile
    } = this.props;
    const classnames = cx('navbar', {
      'navbar-fixed-top': !!fixed,
      'navbar-sm': isMobile ? true : collapsed,
      ['bg-' + theme]: !!theme
    });
    let avatarUrl = getOssFilePath(this.user.avatar)
    // ossFileUtils.getOssFile(
    //   this.user.avatar,
    //   this.user.fileName,
    //   this.user.fileMimeType,
    //   this.user.fileSize,
    //   this.user.fileUri,
    // ).url
    avatarUrl = this.user.avatar ? avatarUrl: require('assets/images/head1.png')

    return (
      <header className={classnames}>
        <div className="navbar-branding">
          <Link className="navbar-brand" to="/">
            <img src={constants.files.sys_main_logo} alt="logo" />
            <b>{constants.env.sys_short_name}</b>
          </Link>
          {/*<span className="toggle_sidemenu_l" onClick={onCollapseLeftSide}>*/}
          {/*  <Icon type="lines" />*/}
          {/*</span>*/}
        </div>
        <div className="navbar-title">
          <b className="navbar-title-brand">{constants.env.sys_full_name}</b>
        </div>
        <ul className="nav navbar-nav navbar-right clearfix">
          <li className="dropdown">
            <Popover
              placement="bottomRight"
              title={'欢迎您,' + this.user.username}
              overlayClassName={cx('navbar-popup', { [theme]: !!theme })}
              content={<UserDropDown />}
              trigger="click"
            >
              <a className="dropdown-toggle">
                <Badge dot>
                  <Avatar src={avatarUrl}>
                    {this.user.username}
                  </Avatar>
                </Badge>
              </a>
            </Popover>
          </li>
        </ul>
        <SearchBox visible={openSearchBox} onClose={this.onCloseSearchBox} />
      </header>
    );
  }
}

const UserDropDown = props => (
  <ul className="dropdown-menu list-group dropdown-persist">
    <li className="list-group-item dropdown-footer">
      <Link to="/sign/login">
        <Icon type="poweroff" /> 退出
      </Link>
    </li>
  </ul>
);

export default NavBarBase;
